import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import {
  ProposalTeamReuseJSON,
  ProposalTeamReuseJSONZ,
} from "work/proposals/drafts-from-previous/proposal-team-reuse";

/**
 * Who on a proposal's teams cannot be carried into a new draft started from it (#1569).
 *
 * Read when the draft is started, never cached for long: whether somebody still works at their
 * organization is exactly the thing that changes between one start and the next.
 */
export const proposalTeamReuseApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProposalTeamReuse: build.query<ProposalTeamReuseJSON, { proposalId: string }>({
      query: ({ proposalId }) => `work/proposals/${proposalId}/team-reuse`,
      rawResponseSchema: ProposalTeamReuseJSONZ,
      onSchemaFailure: logSchemaFailure,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyGetProposalTeamReuseQuery } = proposalTeamReuseApi;
